module.exports = __webpack_public_path__ + "img/icon (8).cee0801e.png";